// extracted by mini-css-extract-plugin
export var root = "AdjustItem-module--root--Fm9pr";
export var AdjustButton = "AdjustItem-module--AdjustButton--li9Om";